import { observable, action, makeObservable, set } from 'mobx';

import { directoryStore } from '../../../core/Stores/DirectoryStore';

export interface NatPolyRelationInputStoreType {
	itemsPerPage: number;
	currentPage: number;
	deleted: boolean;
	order: Array<string>;
	relations: Array<any>;
	oldValue: string;
	timer: any;
	querySelector: any;
	showDropdown: boolean;
	filter: any;
	relation: any;
	modals: Array<number>;
	pluralName: string | null;
	setValue(model: any, key: string, value: any): void;
}

class NatPolyRelationInputStore implements NatPolyRelationInputStoreType {
	constructor() {
		makeObservable(this, {
			itemsPerPage: observable,
			currentPage: observable,
			deleted: observable,
			relations: observable,
			order: observable,
			oldValue: observable,
			timer: observable,
			querySelector: observable,
			showDropdown: observable,
			filter: observable,
			relation: observable,
			modals: observable,
			pluralName: observable,
			setValue: action
		});
	}
	itemsPerPage = 50;
	currentPage = 0;
	deleted = false;
	order = [`name.${directoryStore.models.language} ASC`];
	relations = [] as Array<any>;
	oldValue = '';
	timer = null;
	querySelector = null;
	showDropdown = false;
	filter = null;
	relation = null;
	modals = [];
	pluralName = null;
	setValue(model: any, key: string, value: any) {
		set(model, key, value);
	}
}

export const natPolyRelationInputStore = new NatPolyRelationInputStore();

export default NatPolyRelationInputStore;
